
(function () {
  'use strict';

  // ─── Shared helper ──────────────────────────────────────────────────────────
  function fmtCents(c) {
    var w = Math.floor(c / 100), f = c % 100;
    return w + ',' + (f < 10 ? '0' : '') + f + ' €';
  }

  // ─── Material Selector ──────────────────────────────────────────────────────
  function initMaterialSelector(picker) {
    var sectionId     = picker.id.replace('mat-picker-', '');
    var productHandle = picker.dataset.productHandle || '';
    var cards         = picker.querySelectorAll('.mat-card');
    if (!cards.length) return;

    var currentMatIndex = 0;
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].classList.contains('is-active')) { currentMatIndex = i; break; }
    }

    var _fetchCache = {};

    var galleryCarousel = document.querySelector(
      '#shopify-section-' + sectionId + ' .product-layout__gallery media-carousel'
    );

    function freezeGallery() {
      if (galleryCarousel && galleryCarousel.clientHeight > 0) {
        galleryCarousel.style.maxHeight = galleryCarousel.clientHeight + 'px';
      }
    }

    function thawGallery() {
      if (!galleryCarousel) return;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { galleryCarousel.style.maxHeight = ''; });
      });
    }

    function applyPopupBody(matIndex) {
      var tpl  = document.getElementById('mat-popup-tpl-' + matIndex + '-' + sectionId);
      var body = document.getElementById('mat-popup-body-' + sectionId);
      if (!body) return;
      if (!tpl) {
        var card = cards[matIndex];
        if (card && card.dataset.matUrl !== undefined && !card.dataset.r24Fetching) {
          card.dataset.r24Fetching = '1';
          fetchSectionDoc(card.dataset.matUrl)
            .then(function (doc) {
              delete card.dataset.r24Fetching;
              if (doc) injectFromDoc(doc, matIndex, card.dataset.matUrl);
              applyPopupBody(matIndex);
            })
            .catch(function () { delete card.dataset.r24Fetching; });
        }
        return;
      }
      var nodes = Array.from(tpl.content.cloneNode(true).childNodes);
      body.replaceChildren.apply(body, nodes);
    }

    function getMatIndex(matUrl) {
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].dataset.matUrl === matUrl) return i;
      }
      return 0;
    }

    function switchMaterial(matUrl, updateHistory) {
      var matIndex = getMatIndex(matUrl);
      currentMatIndex = matIndex;

      freezeGallery();

      for (var i = 0; i < cards.length; i++) {
        var active = i === matIndex;
        cards[i].classList.toggle('is-active', active);
        cards[i].setAttribute('aria-checked', active ? 'true' : 'false');

        var descEl = document.getElementById('mat-desc-' + i + '-' + sectionId);
        if (descEl) descEl.hidden = !active;

        var uspsEl = document.getElementById('mat-usps-' + i + '-' + sectionId);
        if (uspsEl) uspsEl.hidden = !active;
      }

      thawGallery();

      // Kick off on-demand fetch if this material's content is still pending
      // (covers browser history navigation before background fetch completed)
      var pendEl = document.getElementById('mat-desc-' + matIndex + '-' + sectionId);
      if (pendEl && pendEl.hasAttribute('data-r24-pending') && matUrl !== undefined) {
        fetchSectionDoc(matUrl)
          .then(function (doc) { if (doc) injectFromDoc(doc, matIndex, matUrl); })
          .catch(function () {});
      }

      var activeCard = cards[matIndex];
      if (activeCard && activeCard.dataset.priceCents) {
        document.dispatchEvent(new CustomEvent('r24:material-switch', {
          detail: { priceCents: parseInt(activeCard.dataset.priceCents, 10), matUrl: matUrl }
        }));
      }

      if (updateHistory !== false) {
        history.pushState({ r24Material: matUrl },
          '', '/products/' + productHandle + (matUrl ? '/' + matUrl : ''));
      }
    }

    // ─── Sections-API fetch (cached per matUrl) ────────────────────────────────
    function fetchSectionDoc(matUrl) {
      if (_fetchCache[matUrl]) return _fetchCache[matUrl];
      var href = '/products/' + productHandle +
        (matUrl ? '/' + matUrl : '') +
        '?sections=' + encodeURIComponent(sectionId);
      _fetchCache[matUrl] = fetch(href)
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (data) {
          var html = data[sectionId];
          return html ? new DOMParser().parseFromString(html, 'text/html') : null;
        });
      return _fetchCache[matUrl];
    }

    // ─── Inject content extracted from a fetched section document ─────────────
    function injectFromDoc(doc, matIndex, matUrl) {
      var isNowActive = cards[matIndex] && cards[matIndex].classList.contains('is-active');

      // mat-desc
      var srcDesc = doc.getElementById('mat-desc-' + matIndex + '-' + sectionId);
      var dstDesc = document.getElementById('mat-desc-' + matIndex + '-' + sectionId);
      if (srcDesc && dstDesc && dstDesc.hasAttribute('data-r24-pending')) {
        dstDesc.innerHTML = srcDesc.innerHTML;
        dstDesc.removeAttribute('data-r24-pending');
      }

      // mat-usps
      var srcUsps = doc.getElementById('mat-usps-' + matIndex + '-' + sectionId);
      var dstUsps = document.getElementById('mat-usps-' + matIndex + '-' + sectionId);
      if (srcUsps && dstUsps && dstUsps.hasAttribute('data-r24-pending')) {
        dstUsps.innerHTML = srcUsps.innerHTML;
        dstUsps.removeAttribute('data-r24-pending');
      }

      // popup template — create fresh <template> from fetched innerHTML
      if (!document.getElementById('mat-popup-tpl-' + matIndex + '-' + sectionId)) {
        var srcTpl = doc.getElementById('mat-popup-tpl-' + matIndex + '-' + sectionId);
        if (srcTpl) {
          var newTpl = document.createElement('template');
          newTpl.id = srcTpl.id;
          newTpl.innerHTML = srcTpl.innerHTML;
          document.body.appendChild(newTpl);
        }
      }

      // delivery badges — fill empty pending placeholder or append new badge div
      var srcBadge = doc.querySelector('.delivery-badges[data-mat-url="' + matUrl + '"]');
      if (srcBadge) {
        var badgeParentId = srcBadge.parentElement && srcBadge.parentElement.id;
        var dstBadgeWrap = badgeParentId ? document.getElementById(badgeParentId) : null;
        if (dstBadgeWrap) {
          var existBadge = dstBadgeWrap.querySelector('.delivery-badges[data-mat-url="' + matUrl + '"]');
          if (existBadge && existBadge.hasAttribute('data-r24-pending')) {
            existBadge.innerHTML = srcBadge.innerHTML;
            existBadge.removeAttribute('data-r24-pending');
          } else if (!existBadge) {
            var clonedBadge = srcBadge.cloneNode(true);
            clonedBadge.hidden = !isNowActive;
            dstBadgeWrap.appendChild(clonedBadge);
          }
        }
      }

      // usp-desktop items
      document.querySelectorAll('[id^="usp-desktop-"]').forEach(function (dstWrap) {
        if (dstWrap.querySelector('[data-mat-url="' + matUrl + '"]')) return;
        var srcWrap = doc.getElementById(dstWrap.id);
        if (!srcWrap) return;
        srcWrap.querySelectorAll('[data-mat-url="' + matUrl + '"]').forEach(function (item) {
          var cl = item.cloneNode(true);
          cl.hidden = !isNowActive;
          dstWrap.appendChild(cl);
        });
      });

      // usp-mobile items
      document.querySelectorAll('[id^="usp-mobile-usps-"]').forEach(function (dstWrap) {
        if (dstWrap.querySelector('[data-mat-url="' + matUrl + '"]')) return;
        var srcWrap = doc.getElementById(dstWrap.id);
        if (!srcWrap) return;
        srcWrap.querySelectorAll('[data-mat-url="' + matUrl + '"]').forEach(function (item) {
          var cl = item.cloneNode(true);
          cl.hidden = !isNowActive;
          dstWrap.appendChild(cl);
        });
      });

      // If this material is currently active re-fire the switch event so marquee
      // and other listeners refresh against the newly injected content
      if (isNowActive) {
        var pc = parseInt((cards[matIndex] || {}).dataset.priceCents, 10) || 0;
        document.dispatchEvent(new CustomEvent('r24:material-switch', {
          detail: { priceCents: pc, matUrl: matUrl }
        }));
      }
    }

    // ─── Background prefetch of all non-active pending materials ──────────────
    function prefetchNonActive() {
      var queue = [];
      for (var j = 0; j < cards.length; j++) {
        if (j === currentMatIndex) continue;
        var el = document.getElementById('mat-desc-' + j + '-' + sectionId);
        if (el && el.hasAttribute('data-r24-pending')) queue.push(j);
      }
      if (!queue.length) return;

      var qi = 0;
      var ric = window.requestIdleCallback
        ? function (fn) { window.requestIdleCallback(fn, { timeout: 1000 }); }
        : function (fn) { setTimeout(fn, 50); };

      function fetchNext() {
        if (qi >= queue.length) return;
        var idx   = queue[qi++];
        var mUrl  = cards[idx] && cards[idx].dataset.matUrl;
        if (mUrl === undefined) { fetchNext(); return; }
        fetchSectionDoc(mUrl)
          .then(function (doc) { if (doc) injectFromDoc(doc, idx, mUrl); ric(fetchNext); })
          .catch(function () { ric(fetchNext); });
      }
      ric(fetchNext);
    }

    var whyBtn = document.getElementById('whyBtn-' + sectionId);
    if (whyBtn) {
      whyBtn.addEventListener('click', function () { applyPopupBody(currentMatIndex); }, { capture: true });
    }

    picker.addEventListener('click', function (e) {
      var card = e.target.closest('.mat-card');
      if (!card) return;
      e.preventDefault();
      switchMaterial(card.dataset.matUrl);
    }, { capture: true });

    cards.forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        var slug = this.dataset.matUrl;
        var href = '/products/' + productHandle + (slug ? '/' + slug : '');
        if (document.querySelector('link[rel="prefetch"][href="' + href + '"]')) return;
        var link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = href;
        document.head.appendChild(link);
      }, { once: true, passive: true });
    });

    window.addEventListener('popstate', function (e) {
      if (e.state && 'r24Material' in e.state) switchMaterial(e.state.r24Material, false);
    });

    prefetchNonActive();
  }

  // ─── Delivery Badges ────────────────────────────────────────────────────────
  function initMarquee(wrap) {
    var track = wrap.querySelector('.delivery-badges__track');
    if (!track) return;
    if (wrap.classList.contains('is-marquee')) wrap.classList.remove('is-marquee');
    if (track.scrollWidth > wrap.offsetWidth) {
      wrap.classList.add('is-marquee');
      wrap.style.setProperty('--r24-marquee-dur', Math.max(36, track.scrollWidth / 10) + 's');
    }
  }

  function refreshActiveMarquee(wrapper) {
    var active = wrapper.querySelector('.delivery-badges:not([hidden])');
    if (active) initMarquee(active);
  }

  function initDeliveryBadges(wrapper) {
    refreshActiveMarquee(wrapper);
    document.addEventListener('r24:material-switch', function (e) {
      wrapper.querySelectorAll('.delivery-badges').forEach(function (b) {
        b.hidden = b.dataset.matUrl !== e.detail.matUrl;
      });
      refreshActiveMarquee(wrapper);
    });
  }

  // ─── Price Block ────────────────────────────────────────────────────────────
  function initPriceBlock(pb) {
    var discPct = parseInt(pb.dataset.discountPct || '0', 10);

    document.addEventListener('r24:material-switch', function (e) {
      var orig = e.detail.priceCents;
      if (!orig) return;
      var disc = discPct > 0 ? Math.round(orig * (100 - discPct) / 100) : orig;
      var save = orig - disc;
      var el;
      el = pb.querySelector('.pb-price-current'); if (el) el.textContent = fmtCents(disc);
      el = pb.querySelector('.pb-price-old');     if (el) el.textContent = fmtCents(orig);
      el = pb.querySelector('.pb-savings-pill');  if (el) el.textContent = 'Du sparst ' + fmtCents(save);
    });

    var endDateStr = pb.dataset.endDate;
    if (endDateStr) {
      var endDate   = new Date(endDateStr).getTime();
      var daysEl    = pb.querySelector('[id^="pb-days-"]');
      var hoursEl   = pb.querySelector('[id^="pb-hours-"]');
      var minutesEl = pb.querySelector('[id^="pb-minutes-"]');
      if (daysEl || hoursEl || minutesEl) {
        var timer = setInterval(function () {
          var distance = endDate - Date.now();
          if (distance <= 0) {
            clearInterval(timer);
            [daysEl, hoursEl, minutesEl].forEach(function (el) { if (el) el.textContent = '0'; });
            return;
          }
          if (daysEl)    daysEl.textContent    = Math.floor(distance / 86400000);
          if (hoursEl)   hoursEl.textContent   = Math.floor((distance % 86400000) / 3600000);
          if (minutesEl) minutesEl.textContent = Math.floor((distance % 3600000) / 60000);
        }, 1000);
      }
    }
  }

  window.pbCopyCode = function (code) {
    if (!code) return;
    navigator.clipboard.writeText(code).then(function () {
      var el = document.createElement('div');
      el.textContent = 'Code erfolgreich kopiert!';
      el.classList.add('copy-promo-code-message');
      document.body.appendChild(el);
      setTimeout(function () { el.remove(); }, 3500);
    });
  };

  // ─── Mobile Primary CTA ─────────────────────────────────────────────────────
  function updateMpcDurations(mpc) {
    function setDur(inner, varName) {
      if (!inner) return;
      mpc.style.setProperty(varName, Math.max(12, (inner.scrollWidth / 2) / 30) + 's');
    }
    setDur(mpc.querySelector('.delivery-badges__inner'), '--mpc-delivery-dur');
    setDur(mpc.querySelector('.mpc-v1__feat-inner'),     '--mpc-feat-dur');
    var payTrack = mpc.querySelector('.mpc-v1__payments-track');
    if (payTrack) mpc.style.setProperty('--mpc-payments-dur', Math.max(30, (payTrack.scrollWidth / 2) / 10) + 's');
  }

  function initMobileCta(mpc) {
    updateMpcDurations(mpc);

    var toggleBtn = mpc.querySelector('.mpc-v1__toggle');
    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        var expanded = mpc.classList.toggle('mpc-v1--expanded');
        toggleBtn.setAttribute('aria-expanded', String(expanded));
        toggleBtn.setAttribute('aria-label', expanded ? 'Details ausblenden' : 'Details einblenden');
      });
    }

    var pill = mpc.querySelector('[aria-controls="mpc-v1-discount-popup"]');
    if (pill) {
      var openPopup = function () {
        var popup = document.getElementById('mpc-v1-discount-popup');
        if (popup && typeof popup.show === 'function') popup.show();
      };
      pill.addEventListener('click', openPopup);
      pill.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openPopup(); }
      });
    }

    var discPct = parseInt(mpc.dataset.discountPct || '0', 10);
    document.addEventListener('r24:material-switch', function (e) {
      var orig = e.detail.priceCents;
      if (!orig) return;
      var disc = discPct > 0 ? Math.round(orig * (100 - discPct) / 100) : orig;
      var el;
      el = mpc.querySelector('.mpc-v1__price-current'); if (el) el.textContent = fmtCents(disc);
      el = mpc.querySelector('.mpc-v1__price-old');     if (el) el.textContent = fmtCents(orig);
    });
  }

  // ─── Secondary CTA ──────────────────────────────────────────────────────────
  function initSecondaryCta(cta) {
    document.addEventListener('r24:material-switch', function (e) {
      cta.querySelectorAll('[data-mat-url]').forEach(function (el) {
        el.hidden = el.dataset.matUrl !== e.detail.matUrl;
      });
    });
  }

  // ─── Question Popup ─────────────────────────────────────────────────────────
  function initQuestionPp(el) {
    document.addEventListener('r24:material-switch', function (e) {
      el.querySelectorAll('.qppv1__mat-group').forEach(function (g) {
        g.hidden = g.dataset.matUrl !== e.detail.matUrl;
      });
    });
  }

  // ─── USP Blocks (desktop + mobile) ──────────────────────────────────────────
  function initUspBlock(el) {
    document.addEventListener('r24:material-switch', function (e) {
      el.querySelectorAll('[data-mat-url]').forEach(function (g) {
        g.hidden = g.dataset.matUrl !== e.detail.matUrl;
      });
    });
  }

  // ─── Phase 1: critical — material selector only (synchronous) ───────────────
  function initCritical() {
    document.querySelectorAll('.mat-picker[id^="mat-picker-"]').forEach(initMaterialSelector);
  }

  // ─── Phase 2: deferred — everything else (idle or ≤500 ms) ──────────────────
  function initDeferred() {
    var r24El = document.getElementById('r24-page-data');
    if (r24El) {
      try {
        var r24d = JSON.parse(r24El.textContent);
        window.R24 = window.R24 || {};
        window.R24.variants = r24d.variants;
        window.R24.countdownSeconds = r24d.countdownSeconds;
      } catch (e) {}
    }

    document.querySelectorAll('[id^="delivery-badges-"]').forEach(initDeliveryBadges);
    document.querySelectorAll('[id^="price-block-"]').forEach(initPriceBlock);
    var mpc = document.getElementById('mpc-v1');
    if (mpc) initMobileCta(mpc);
    document.querySelectorAll('[id^="sec-cta-"]').forEach(initSecondaryCta);
    document.querySelectorAll('[id^="qppv1-"]').forEach(initQuestionPp);
    document.querySelectorAll('[id^="usp-desktop-"], [id^="usp-mobile-usps-"]').forEach(initUspBlock);

    window.addEventListener('resize', function () {
      document.querySelectorAll('[id^="delivery-badges-"]').forEach(refreshActiveMarquee);
      var m = document.getElementById('mpc-v1');
      if (m) updateMpcDurations(m);
    }, { passive: true });
  }

  var scheduleDeferred = window.requestIdleCallback
    ? function (fn) { window.requestIdleCallback(fn, { timeout: 500 }); }
    : function (fn) { setTimeout(fn, 0); };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCritical();
      scheduleDeferred(initDeferred);
    });
  } else {
    initCritical();
    scheduleDeferred(initDeferred);
  }
})();
